











































































































import { parseISO, format } from 'date-fns'
import { Component, Vue } from 'vue-property-decorator'

import { ELSA_API_LOCATION } from '@/api'
import {
  getIlmoitukset,
  getSeuraavaPaivitys,
  getLoginNameMismatch,
  LoginNameMismatch
} from '@/api/julkinen'
import ElsaButton from '@/components/button/button.vue'
import RichTextContent from '@/components/rich-text-content/rich-text-content.vue'
import { Ilmoitus } from '@/types'

@Component({
  components: {
    ElsaButton,
    RichTextContent
  }
})
export default class Login extends Vue {
  huoltokatkoNotification = false
  HuoltokatkoDay = ''
  HuoltokatkoDate = ''
  HuoltokatkoTime = ''
  ilmoitukset: Ilmoitus[] | null = null
  nameMismatch: LoginNameMismatch | null = null

  async mounted() {
    if (this.invalidName) {
      try {
        const response = await getLoginNameMismatch()
        this.nameMismatch = response.data || null
      } catch {
        // Keep the existing error and contact instructions if details are unavailable.
        this.nameMismatch = null
      }
    }
    this.handleHuoltokatkoDates((await getSeuraavaPaivitys()).data)
    this.ilmoitukset = (await getIlmoitukset()).data
  }

  loginSuomiFi() {
    const token = this.$route.query.token
    return (window.location.href = token
      ? `${ELSA_API_LOCATION}/saml2/authenticate/suomifi?RelayState=${this.$route.query.token}`
      : `${ELSA_API_LOCATION}/saml2/authenticate/suomifi`)
  }

  handleHuoltokatkoDates(dateStr: string) {
    if (dateStr !== '') {
      const date = parseISO(dateStr)
      this.huoltokatkoNotification = true
      this.HuoltokatkoDay = format(date, 'ccc')
      this.HuoltokatkoDate = format(date, 'dd.MM.')
      this.HuoltokatkoTime = format(date, 'HH.mm')
    }
  }

  get virhe() {
    return this.$route.query.virhe
  }

  get showMail() {
    return (
      this.$route.query.virhe === 'EI_KAYTTO_OIKEUTTA' ||
      this.$route.query.virhe === 'VIRHEELLINEN_NIMI' ||
      this.$route.query.virhe === 'OPINTO_OIKEUS_TULEVAISUUDESSA'
    )
  }

  get noUseRights() {
    return this.$route.query.virhe === 'EI_KAYTTO_OIKEUTTA'
  }

  get invalidName() {
    return this.$route.query.virhe === 'VIRHEELLINEN_NIMI'
  }

  get contactMail() {
    return 'julia.sillanpaa@tuni.fi'
  }

  get appVersion() {
    return process.env.VUE_APP_VERSION || ''
  }
}
